import React from 'react'
import gql from 'graphql-tag'
import { useMutation } from '@apollo/react-hooks'
import { Modal, Button } from 'react-bootstrap'
import PropTypes from 'prop-types'

const GET_UNDELETE_QUERY = gql`
  mutation UndeleteQuery($input: DeleteFileInput!) {
    undeleteFile(input: $input) {
      id
    }
  }
`
export default function RestoreFileModal(props) {
  const [restoreFile] = useMutation(GET_UNDELETE_QUERY, {
    variables: {
      input: {
        cuid: props.row.cuid,
        key: props.itemId + '/' + props.row.name,
      },
    },
  })

  return (
    <Modal {...props} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Restore File</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form
          onSubmit={(e) => {
            e.preventDefault()
            restoreFile().then(
              (result) => {
                if (result.data.undeleteFile.id != null)
                  window.location.reload()
                else props.onRestoreFailed()
              },
              (error) => {
                console.log('Delete file failed with error: ', error)
                props.onHide()
              }
            )
            props.onHide()
          }}
        >
          {props.restoreFailed ? (
            <h3>Failed to restore {props.row.name}</h3>
          ) : (
            <h3>You are about to restore a file: {props.row.name}</h3>
          )}
          <br />
          {props.restoreFailed ? (
            <p>An error was encountered when attempting to restore the file.</p>
          ) : (
            <p>Your file will be restored to this item.</p>
          )}
          <Modal.Footer>
            <Button variant="secondary" onClick={props.onHide}>
              Close
            </Button>
            <Button
              variant="primary"
              type="submit"
              hidden={props.restoreFailed}
            >
              Restore File
            </Button>
          </Modal.Footer>
        </form>
      </Modal.Body>
    </Modal>
  )
}

RestoreFileModal.propTypes = {
  row: PropTypes.shape({
    cuid: PropTypes.string,
    bucket: PropTypes.string,
    key: PropTypes.string,
    name: PropTypes.string,
  }),
  onHide: PropTypes.func,
  onRestoreFailed: PropTypes.func,
  itemId: PropTypes.string,
  restoreFailed: PropTypes.bool,
}
